import { createSelector } from 'reselect'

const interactiveVideoData = state => state.interactiveVideoCreation

const assetsSelector = createSelector(
	[ interactiveVideoData ],
	interactiveVideo => ({
		videoUid: interactiveVideo.media.asset.uid,
		posterUid: interactiveVideo.media.posterUid,
	})
)

export default assetsSelector
